import styled from 'styled-components';

export const LoadingContainer = styled.div`
  width: 100%;
`;

export const ErrorText = styled.p`
  width: 100%;
  text-align: center;
  font-size: 1rem;
`;
